<template>
  <div class="gift-list">
    <h1>Co bychom si přáli?</h1>
    <ul>
      <Gift v-for="gift in gifts"
            :key="`gift-${gift.id}`"
            v-bind="gift"/>
    </ul>
  </div>
</template>

<script>
import Gift from '@/components/Gift.vue';
import { fetchGifts } from '@/services';

export default {
  name: 'Home',
  components: {
    Gift,
  },
  data() {
    return {
      gifts: [],
    };
  },
  async created() {
    const gifts = await fetchGifts().catch((error) => console.error(error));

    if (gifts) {
      this.gifts = gifts;
    }
  },
};
</script>

<style lang="scss">
  .gift-list {
    &__background {
      width: 100%;
      height: 200px;
      background-position: center;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    h1 {
      text-align: center;
    }
  }
</style>
